<template>
    <div>
        <div class="leaves_top"></div>

        <HeaderMenu_Admin />
        <LateralMenu_Admin />

        <div id="admin">
            <div class="calendrier-container content">
                <div class="admin-tools header">
                    <router-link to="/admin/logout" v-slot="{ href }">
                        <button v-bind:href="href">Déconnexion</button>
                    </router-link>
                </div>

                <span class="title">Enregistrer une réservation</span>
                <div class="admin-tools header">
                    <button v-on:click="addReservation_clicked('le-tombeau-de-siptah')">Le tombeau<br />de Siptah</button>
                    &nbsp;
                    <button v-on:click="addReservation_clicked('le-secret-de-mayoko')">Le secret<br />de Mayoko</button>
                    &nbsp;
                    <button v-on:click="addReservation_clicked('les-gardiens-de-vichama')">Les gardiens<br />de Vichama</button>
                    &nbsp;
                    <button v-on:click="addReservation_clicked('le-talisman-des-titans')">Le talisman<br />des Titans</button>
                    &nbsp;
                    <button v-on:click="addReservation_clicked('la-legende-d-ishtar')">La légende<br />d'Ishtar</button>
                    &nbsp;
                    <button v-on:click="addReservation_clicked('nestor-bomb-simulator')">NESTOR<br />Bomb Simulator</button>
                </div>

                <span class="title">Horaires d'ouverture</span>
                <Calendrier v-bind:view_isAdmin="true" ref="calendrierComponent"
                    v-on:calendrier_daySelected="calendrier_daySelected" v-on:calendrier_dayUnselected="calendrier_dayUnselected" />

                <div id="planning" v-if="creneaux_jour && reservations">
                    <span class="subtitle">
                        Horaires du {{ calendarDay }} {{ calendarLabel }}
                        &nbsp;<i class="fa-solid fa-calendar-check" v-on:click="creneauxSetAvailability_clickAll(true)"></i>
                        &nbsp;<i class="fa-solid fa-calendar-xmark" v-on:click="creneauxSetAvailability_clickAll(false)"></i>
                    </span>
                    <span class="creneaux_infos responsive-block mw960">Nombre de créneaux réservés : {{ creneaux_nb_rooms_reservation }} / {{ creneaux_nb_rooms_available }}</span>
                    
                    <div class="creneaux-rooms">
                        <div class="creneaux">
                            <div v-for="creneaux_set_key in creneaux_sets_keys">
                                <span class="header-top">
                                    <template v-if="creneauAlloc_processStep == 'requesting' && creneauAlloc_processId == creneaux_set_key">
                                        Dispo.
                                        &nbsp;<Loader_Mini />
                                    </template>
                                    <template v-else-if="creneauAlloc_processStep == 'done' && creneauAlloc_processId == creneaux_set_key">
                                        Dispo.
                                        &nbsp;<Checkmark />
                                    </template>
                                    <template v-else>
                                        Dispo.
                                        &nbsp;<input type="text" v-model="creneaux_sets[creneaux_set_key].game_master_nb" v-on:change="update_creneauxSetAlloc(creneaux_set_key)" />
                                    </template>
                                </span>
                            </div>
                        </div>

                        <div class="creneaux">
                            <div v-for="creneaux_set_key in creneaux_sets_keys">
                                <span v-if="creneauxSetAvailability_processId == creneaux_set_key" class="header-subtop">
                                    <Loader_Mini />
                                </span>
                                <span v-else-if="checkCreneauxSet_availability(creneaux_set_key) === false" v-on:click="creneauxSetAvailability_click(creneaux_set_key, true)" 
                                    class="header-subtop">Ouvrir tout</span>
                                <span v-else-if="checkCreneauxSet_availability(creneaux_set_key) === true" v-on:click="creneauxSetAvailability_click(creneaux_set_key, false)" 
                                    class="header-subtop">Fermer tout</span>
                            </div>
                        </div>
                    </div>

                    <div class="creneaux-rooms normal-block mw960">
                        <div class="header-left">
                            <span>Siptah</span>
                            <span>Mayoko</span>
                            <span>Ishtar</span>
                        </div>
                        <div class="creneaux">
                            <div v-for="creneau_key in creneaux_keys" v-if="'room_1' in creneaux_jour[creneau_key].availability || 'room_2' in creneaux_jour[creneau_key].availability">
                                <span class="header-top">
                                    {{ creneaux_jour[creneau_key].label }}
                                </span>

                                <span class="creneau" v-bind:class="creneauRoom_bindClass(creneau_key, 1)" v-bind:title="creneauRoom_debugAvailableType(creneau_key, 1)">
                                    <div class="mode-decouverte-highlight" v-if="checkGameModeHighlight('decouverte', creneau_key, 1)">&nbsp;</div>
                                    <div class="mode-confirme-highlight" v-else-if="checkGameModeHighlight('confirme', creneau_key, 1)">&nbsp;</div>
                                    
                                    <template v-if="creneaux_jour[creneau_key].reservations['room_1']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 1)">Réservé</span>
                                    </template>
                                    <template v-else-if="creneaux_jour[creneau_key].availability['room_1']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 1)">Ouv.</span>
                                        <template v-if="creneauRoom_checkExceptions(creneau_key, 1)">  
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 1)"> &#x260E</span>
                                        </template>
                                        <template v-else>
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 1)"> &#xFF20</span>
                                        </template>
                                    </template>
                                    <template v-else-if="!creneaux_jour[creneau_key].availability['room_1']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 1)">Fermé</span>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </span>

                                <span class="creneau" v-bind:class="creneauRoom_bindClass(creneau_key, 2)" v-bind:title="creneauRoom_debugAvailableType(creneau_key, 2)">
                                    <div class="mode-decouverte-highlight" v-if="checkGameModeHighlight('decouverte', creneau_key, 2)">&nbsp;</div>
                                    <div class="mode-confirme-highlight" v-else-if="checkGameModeHighlight('confirme', creneau_key, 2)">&nbsp;</div>
                                    
                                    <template v-if="creneaux_jour[creneau_key].reservations['room_2']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 2)">Réservé</span>
                                    </template>
                                    <template v-else-if="creneaux_jour[creneau_key].availability['room_2']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 2)">Ouv.</span>
                                        <template v-if="creneauRoom_checkExceptions(creneau_key, 2)">  
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 2)"> &#x260E</span>
                                        </template>
                                        <template v-else>
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 2)"> &#xFF20</span>
                                        </template>
                                    </template>
                                    <template v-else-if="!creneaux_jour[creneau_key].availability['room_2']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 2)">Fermé</span>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </span>

                                <span class="creneau" v-bind:class="creneauRoom_bindClass(creneau_key, 5)" v-bind:title="creneauRoom_debugAvailableType(creneau_key, 5)">
                                    <div class="mode-decouverte-highlight" v-if="checkGameModeHighlight('decouverte', creneau_key, 5)">&nbsp;</div>
                                    <div class="mode-confirme-highlight" v-else-if="checkGameModeHighlight('confirme', creneau_key, 5)">&nbsp;</div>
                                    <div v-bind:class="getNumeroEpisodeHighlight(creneau_key)">&nbsp;</div>
                                    
                                    <template v-if="creneaux_jour[creneau_key].reservations['room_5']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 5)">Réservé</span>
                                    </template>
                                    <template v-else-if="creneaux_jour[creneau_key].availability['room_5']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 5)">Ouv.</span>
                                        <template v-if="creneauRoom_checkExceptions(creneau_key, 5)">  
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 5)"> &#x260E</span>
                                        </template>
                                        <template v-else>
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 5)"> &#xFF20</span>
                                        </template>
                                    </template>
                                    <template v-else-if="!creneaux_jour[creneau_key].availability['room_5']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 5)">Fermé</span>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="creneaux-rooms responsive-block mw960">
                        <div class="creneaux">
                            <div v-for="creneau_key in creneaux_keys" v-bind:class="creneauRoom_Container_bindClass(creneau_key)" 
                                v-if="'room_1' in creneaux_jour[creneau_key].availability || 'room_2' in creneaux_jour[creneau_key].availability || 'room_5' in creneaux_jour[creneau_key].availability">
                                <span class="header-top">
                                    {{ creneaux_jour[creneau_key].label }}
                                </span>
                            </div>
                        </div>
                        <div class="header-left">
                            <span>Siptah</span>
                        </div>
                        <div class="creneaux">
                            <div v-for="creneau_key in creneaux_keys" v-bind:class="creneauRoom_Container_bindClass(creneau_key)" 
                                v-if="'room_1' in creneaux_jour[creneau_key].availability">
                                <span class="creneau" v-bind:class="creneauRoom_bindClass(creneau_key, 1)" v-bind:title="creneauRoom_debugAvailableType(creneau_key, 1)">
                                    <div class="mode-decouverte-highlight" v-if="checkGameModeHighlight('decouverte', creneau_key, 1)">&nbsp;</div>
                                    <div class="mode-confirme-highlight" v-else-if="checkGameModeHighlight('confirme', creneau_key, 1)">&nbsp;</div>
                                    
                                    <template v-if="creneaux_jour[creneau_key].reservations['room_1']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 1)">Réservé</span>
                                    </template>
                                    <template v-else-if="creneaux_jour[creneau_key].availability['room_1']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 1)">Ouv.</span>
                                        <template v-if="creneauRoom_checkExceptions(creneau_key, 1)">  
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 1)"> &#x260E</span>
                                        </template>
                                        <template v-else>
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 1)"> &#xFF20</span>
                                        </template>
                                    </template>
                                    <template v-else-if="!creneaux_jour[creneau_key].availability['room_1']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 1)">Fermé</span>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </span>
                            </div>
                        </div>
                        <div class="header-left">
                            <span>Mayoko</span>
                        </div>
                        <div class="creneaux">
                            <div v-for="creneau_key in creneaux_keys" v-bind:class="creneauRoom_Container_bindClass(creneau_key)" 
                                v-if="'room_2' in creneaux_jour[creneau_key].availability">
                                <span class="creneau" v-bind:class="creneauRoom_bindClass(creneau_key, 2)" v-bind:title="creneauRoom_debugAvailableType(creneau_key, 2)">
                                    <div class="mode-decouverte-highlight" v-if="checkGameModeHighlight('decouverte', creneau_key, 2)">&nbsp;</div>
                                    <div class="mode-confirme-highlight" v-else-if="checkGameModeHighlight('confirme', creneau_key, 2)">&nbsp;</div>
                                    
                                    <template v-if="creneaux_jour[creneau_key].reservations['room_2']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 2)">Réservé</span>
                                    </template>
                                    <template v-else-if="creneaux_jour[creneau_key].availability['room_2']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 2)">Ouv.</span>
                                        <template v-if="creneauRoom_checkExceptions(creneau_key, 2)">  
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 2)"> &#x260E</span>
                                        </template>
                                        <template v-else>
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 2)"> &#xFF20</span>
                                        </template>
                                    </template>
                                    <template v-else-if="!creneaux_jour[creneau_key].availability['room_2']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 2)">Fermé</span>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </span>
                            </div>
                        </div>
                        <div class="header-left">
                            <span>Ishtar</span>
                        </div>
                        <div class="creneaux">
                            <div v-for="creneau_key in creneaux_keys" v-bind:class="creneauRoom_Container_bindClass(creneau_key)" 
                                v-if="'room_5' in creneaux_jour[creneau_key].availability">
                                <span class="creneau" v-bind:class="creneauRoom_bindClass(creneau_key, 5)" v-bind:title="creneauRoom_debugAvailableType(creneau_key, 5)">
                                    <div class="mode-decouverte-highlight" v-if="checkGameModeHighlight('decouverte', creneau_key, 5)">&nbsp;</div>
                                    <div class="mode-confirme-highlight" v-else-if="checkGameModeHighlight('confirme', creneau_key, 5)">&nbsp;</div>
                                    <div v-bind:class="getNumeroEpisodeHighlight(creneau_key)">&nbsp;</div>
                                    
                                    <template v-if="creneaux_jour[creneau_key].reservations['room_5']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 5)">Réservé</span>
                                    </template>
                                    <template v-else-if="creneaux_jour[creneau_key].availability['room_5']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 5)">Ouv.</span>
                                        <template v-if="creneauRoom_checkExceptions(creneau_key, 5)">  
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 5)"> &#x260E</span>
                                        </template>
                                        <template v-else>
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 5)"> &#xFF20</span>
                                        </template>
                                    </template>
                                    <template v-else-if="!creneaux_jour[creneau_key].availability['room_5']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 5)">Fermé</span>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="creneaux-rooms normal-block mw960">
                        <div class="header-left">
                            <span>Vichama</span>
                        </div>
                        <div class="creneaux">
                            <div v-for="creneau_key in creneaux_keys" v-if="'room_3' in creneaux_jour[creneau_key].availability">
                                <span class="header-top">
                                    {{ creneaux_jour[creneau_key].label }}
                                </span>

                                <span class="creneau" v-bind:class="creneauRoom_bindClass(creneau_key, 3)" v-bind:title="creneauRoom_debugAvailableType(creneau_key, 3)">
                                    <div class="mode-decouverte-highlight" v-if="checkGameModeHighlight('decouverte', creneau_key, 3)">&nbsp;</div>
                                    <div class="mode-confirme-highlight" v-else-if="checkGameModeHighlight('confirme', creneau_key, 3)">&nbsp;</div>
                                    
                                    <template v-if="creneaux_jour[creneau_key].reservations['room_3']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 3)">Réservé</span>
                                    </template>
                                    <template v-else-if="creneaux_jour[creneau_key].availability['room_3']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 3)">Ouv.</span>
                                        <template v-if="creneauRoom_checkExceptions(creneau_key, 3)">  
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 3)"> &#x260E</span>
                                        </template>
                                        <template v-else>
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 3)"> &#xFF20</span>
                                        </template>
                                    </template>
                                    <template v-else-if="!creneaux_jour[creneau_key].availability['room_3']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 3)">Fermé</span>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </span>
                            </div>
                        </div>
                        <div class="header-left">
                            <span>Talisman</span>
                        </div>
                        <div class="creneaux">
                            <div v-for="creneau_key in creneaux_keys" v-if="'room_4' in creneaux_jour[creneau_key].availability">
                                <span class="creneau" v-bind:class="creneauRoom_bindClass(creneau_key, 4)" v-bind:title="creneauRoom_debugAvailableType(creneau_key, 4)">
                                    <div class="mode-decouverte-highlight" v-if="checkGameModeHighlight('decouverte', creneau_key, 4)">&nbsp;</div>
                                    <div class="mode-confirme-highlight" v-else-if="checkGameModeHighlight('confirme', creneau_key, 4)">&nbsp;</div>
                                    
                                    <template v-if="creneaux_jour[creneau_key].reservations['room_4']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 4)">Réservé</span>
                                    </template>
                                    <template v-else-if="creneaux_jour[creneau_key].availability['room_4']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 4)">Ouv.</span>
                                        <template v-if="creneauRoom_checkExceptions(creneau_key, 4)">  
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 4)"> &#x260E</span>
                                        </template>
                                        <template v-else>
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 4)"> &#xFF20</span>
                                        </template>
                                    </template>
                                    <template v-else-if="!creneaux_jour[creneau_key].availability['room_4']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 4)">Fermé</span>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </span>
                            </div>
                        </div>
                        <div class="header-left">
                            <span>NESTOR</span>
                        </div>
                        <div class="creneaux">
                            <div v-for="creneau_key in creneaux_keys" v-if="'room_6' in creneaux_jour[creneau_key].availability">
                                <span class="creneau" v-bind:class="creneauRoom_bindClass(creneau_key, 6)" v-bind:title="creneauRoom_debugAvailableType(creneau_key, 6)">
                                    <template v-if="creneaux_jour[creneau_key].reservations['room_6']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 6)">Réservé</span>
                                    </template>
                                    <template v-else-if="creneaux_jour[creneau_key].availability['room_6']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 6)">Ouv.</span>
                                        <template v-if="creneauRoom_checkExceptions(creneau_key, 6)">  
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 6)"> &#x260E</span>
                                        </template>
                                        <template v-else>
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 6)"> &#xFF20</span>
                                        </template>
                                    </template>
                                    <template v-else-if="!creneaux_jour[creneau_key].availability['room_6']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 6)">Fermé</span>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="creneaux-rooms responsive-block mw960">
                        <div class="creneaux">
                            <div v-for="creneau_key in creneaux_keys" v-bind:class="creneauRoom_Container_bindClass(creneau_key)" 
                                v-if="'room_3' in creneaux_jour[creneau_key].availability || 'room_4' in creneaux_jour[creneau_key].availability">
                                <span class="header-top">
                                    {{ creneaux_jour[creneau_key].label }}
                                </span>
                            </div>
                        </div>
                        <div class="header-left">
                            <span>Vichama</span>
                        </div>
                        <div class="creneaux">
                            <div v-for="creneau_key in creneaux_keys" v-bind:class="creneauRoom_Container_bindClass(creneau_key)" 
                                v-if="'room_3' in creneaux_jour[creneau_key].availability">
                                <span class="creneau" v-bind:class="creneauRoom_bindClass(creneau_key, 3)" v-bind:title="creneauRoom_debugAvailableType(creneau_key, 3)">
                                    <div class="mode-decouverte-highlight" v-if="checkGameModeHighlight('decouverte', creneau_key, 3)">&nbsp;</div>
                                    <div class="mode-confirme-highlight" v-else-if="checkGameModeHighlight('confirme', creneau_key, 3)">&nbsp;</div>
                                    
                                    <template v-if="creneaux_jour[creneau_key].reservations['room_3']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 3)">Réservé</span>
                                    </template>
                                    <template v-else-if="creneaux_jour[creneau_key].availability['room_3']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 3)">Ouv.</span>
                                        <template v-if="creneauRoom_checkExceptions(creneau_key, 3)">  
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 3)"> &#x260E</span>
                                        </template>
                                        <template v-else>
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 3)"> &#xFF20</span>
                                        </template>
                                    </template>
                                    <template v-else-if="!creneaux_jour[creneau_key].availability['room_3']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 3)">Fermé</span>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </span>
                            </div>
                        </div>
                        <div class="header-left">
                            <span>Talisman</span>
                        </div>
                        <div class="creneaux">
                            <div v-for="creneau_key in creneaux_keys" v-bind:class="creneauRoom_Container_bindClass(creneau_key)" 
                                v-if="'room_4' in creneaux_jour[creneau_key].availability">
                                <span class="creneau" v-bind:class="creneauRoom_bindClass(creneau_key, 4)" v-bind:title="creneauRoom_debugAvailableType(creneau_key, 4)">
                                    <div class="mode-decouverte-highlight" v-if="checkGameModeHighlight('decouverte', creneau_key, 4)">&nbsp;</div>
                                    <div class="mode-confirme-highlight" v-else-if="checkGameModeHighlight('confirme', creneau_key, 4)">&nbsp;</div>
                                    
                                    <template v-if="creneaux_jour[creneau_key].reservations['room_4']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 4)">Réservé</span>
                                    </template>
                                    <template v-else-if="creneaux_jour[creneau_key].availability['room_4']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 4)">Ouv.</span>
                                        <template v-if="creneauRoom_checkExceptions(creneau_key, 4)">  
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 4)"> &#x260E</span>
                                        </template>
                                        <template v-else>
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 4)"> &#xFF20</span>
                                        </template>
                                    </template>
                                    <template v-else-if="!creneaux_jour[creneau_key].availability['room_4']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 4)">Fermé</span>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </span>
                            </div>
                        </div>
                        <div class="header-left">
                            <span>NESTOR</span>
                        </div>
                        <div class="creneaux">
                            <div v-for="creneau_key in creneaux_keys" v-bind:class="creneauRoom_Container_bindClass(creneau_key)" 
                                v-if="'room_6' in creneaux_jour[creneau_key].availability">
                                <span class="creneau" v-bind:class="creneauRoom_bindClass(creneau_key, 6)" v-bind:title="creneauRoom_debugAvailableType(creneau_key, 6)">
                                    <template v-if="creneaux_jour[creneau_key].reservations['room_6']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 6)">Réservé</span>
                                    </template>
                                    <template v-else-if="creneaux_jour[creneau_key].availability['room_6']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 6)">Ouv.</span>
                                        <template v-if="creneauRoom_checkExceptions(creneau_key, 6)">  
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 6)"> &#x260E</span>
                                        </template>
                                        <template v-else>
                                            &nbsp;<span v-on:click="creneauRoomAvailabilityException_clicked(creneau_key, 6)"> &#xFF20</span>
                                        </template>
                                    </template>
                                    <template v-else-if="!creneaux_jour[creneau_key].availability['room_6']">
                                        <span v-on:click="creneauRoom_clicked(creneau_key, 6)">Fermé</span>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="calendrier-error" v-else>
                    Cliquez sur une date dans le calendrier pour afficher
                    <br />l'organisation des créneaux et les actions contextuelles.
                </div>

                <span class="title" v-if="creneaux_jour">Outils</span>
                <div class="admin-tools footer" v-if="creneaux_jour">
                    <button class="feuille-de-caisse" v-on:click="feuilleCaisse_clicked">Feuille de caisse</button>
                </div>
            </div>

            <div class="reservations-container content" v-if="creneaux_jour">
                <span class="title">Réservations du {{ calendarDay }} {{ calendarLabel }}</span>
                <div id="liste-reservations">
                    <template v-for="reservation in reservations">
                        <div v-for="scenario in reservation.scenarios"> 
                            <span>{{ scenario.creneau_label }}</span>
                            <span>{{ scenario.room_label }}</span>
                            <span>{{ reservation.first_name }} {{ reservation.last_name }}</span>
                            <span>{{ reservation.team_name }}</span>
                            <span>{{ scenario.composition }} <i class="fa fa-people-group"></i></span>
                            <span>
                                <template v-if="reservation.language != 'FR'">{{ reservation.language }}</template>
                                <template v-else>&nbsp;</template>
                            </span>
                            <i v-bind:class="btnThanksEmail_bindClass(reservation)" v-on:click="btnThanksEmail_onClick(reservation)"></i>
                            <i v-bind:class="btnReservationComment_bindClass(reservation)" v-on:click="btnReservationComment_onClick(reservation, scenario)"></i>
                            <div class="btn-closure" v-on:click="btnClosure_onClick(reservation)"></div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div id="leaves_sides">
            <div class="left"></div>
            <div class="right"></div>
        </div>

        <Reservation ref="reservationPopin" v-bind:view_paymentDelayed="true" />
        <ReservationComment ref="reservationCommentPopin" />

        <Footer />
    </div>
</template>

<script>
import HeaderMenu_Admin from '../../components/HeaderMenu_Admin.vue';
import LateralMenu_Admin from '../../components/LateralMenu_Admin.vue';

import Footer from '../../components/Footer.vue';
import Calendrier from '../../components/Calendrier.vue';
import Reservation from '../../components/Reservation.vue';
import ReservationComment from '../../components/ReservationComment.vue';
import Loader_Mini from '../../components/Loader_Mini.vue';
import Checkmark from '../../components/Checkmark.vue';

import axios from 'axios';

export default {
    name: "Admin_ReservationsPage",
    components: {
        HeaderMenu_Admin,
        LateralMenu_Admin,
        Footer,
        Calendrier,
        Reservation,
        ReservationComment,
        Loader_Mini,
        Checkmark
    },
    data: () => ({
        // data
        game_master_colors: [ '#6b429b', '#ec145c', '#00b14c', '#45a6dd', '#24e3d6', '#e49827', '#e3db24' ],
        // informations from calendrier component
        creneaux_type: null,
        creneaux_keys: null,
        creneaux_sets_keys: null,
        creneaux_jour: null,
        creneaux_sets: null,
        calendarLabel: null,
        calendarDay: null,
        calendarMonth: null,
        calendarYear: null,
        calendarIndex: null,
        // reservations informations
        reservations: null,
        // processing
        admin_isProcessing: false,
        creneauAlloc_processStep: null,
        creneauAlloc_processId: null,
        creneauxSetAvailability_processId: null
    }),
    methods: {
        redirect: function(url) {
            window.open(url, '_blank');
        },
        addReservation_clicked: function(scenario_slug) {
            this.$refs.reservationPopin.popin_reservationDisplayed(scenario_slug);
        },
        feuilleCaisse_clicked: function() {
            this.redirect('https://api.lockquest.fr/reservations/' + this.calendarDay + '/' + this.calendarMonth + '/' + this.calendarYear + '/pdf');
        },
        getNumeroEpisodeHighlight: function(creneau_key) {
            var result = {};
            result['num-episode-highlight'] = true;

            for (var i = 0; i < this.reservations.length; i++) {
                for (var j = 0; j < this.reservations[i].scenarios.length; j++) {
                    if (this.reservations[i].scenarios[j].creneau == creneau_key) {
                        if (!this.reservations[i].scenarios[j].format_episode && !this.reservations[i].scenarios[j].numero_episode) {
                            break;
                        }

                        result[this.reservations[i].scenarios[j].format_episode + '-' + this.reservations[i].scenarios[j].numero_episode] = true;
                    }
                }
            }

            return result;
        },
        checkGameModeHighlight: function(game_mode, creneau_key, room_number) {
            for (var i = 0; i < this.reservations.length; i++) {
                for (var j = 0; j < this.reservations[i].scenarios.length; j++) {
                    if (this.reservations[i].scenarios[j].creneau == creneau_key && this.reservations[i].scenarios[j].room == ('room_' + room_number)
                        && this.reservations[i].scenarios[j].game_mode == game_mode) {
                            return true;
                        }
                }
            }

            return false;
        },
        creneauRoom_debugAvailableType: function(creneau_key, room_number) {
            return this.creneaux_jour[creneau_key].type + ' / ' + this.creneaux_jour[creneau_key].exceptions['room_' + room_number];
        },
        creneauRoom_checkAvailability: function(creneau_key, room_number) {
            return this.creneaux_jour[creneau_key].availability['room_' + room_number];
        },
        creneauRoom_checkExceptions: function(creneau_key, room_number) {
            if (this.creneaux_jour[creneau_key].exceptions['room_' + room_number]) {
                return this.creneaux_jour[creneau_key].exceptions['room_' + room_number] == 'available_phone';
            } else {
                if (this.creneaux_jour[creneau_key].type == 'available_phone') {
                    return true;
                } else if (this.creneaux_jour[creneau_key].type == 'full') {
                    return this.isTodaySelected ? true : false;
                }
            }
        },
        creneauRoom_getAvailableType: function(creneau_key, room_number) {
            if (this.creneaux_jour[creneau_key].exceptions['room_' + room_number]) {
                return this.creneaux_jour[creneau_key].exceptions['room_' + room_number];
            } else {
                return this.creneaux_jour[creneau_key].type;
            }
            /*switch(this.creneaux_jour[creneau_key].type) {
                case 'not_available':
                    return 'not_available';
                    break;
                case 'available':
                case 'available_phone':
                    if (this.creneaux_jour[creneau_key].exceptions['room_' + room_number]) {
                        return this.creneaux_jour[creneau_key].exceptions['room_' + room_number];
                    } else {
                        return this.creneaux_jour[creneau_key].type;
                    }
                    break;
                case 'full':
                    if (this.creneaux_jour[creneau_key].exceptions['room_' + room_number]) {
                        return this.creneaux_jour[creneau_key].exceptions['room_' + room_number];
                    } else {
                        return 'available';
                    }
                    break;
            }

            return 'not_available';*/
        },
        btnReservationComment_bindClass: function(reservation) {
            var result = {};
            result['fa-comment'] = true;

            if (reservation.comment) {
                result['fa-solid'] = true;
            } else {
                result['fa-regular'] = true;
            }

            return result;
        },
        btnThanksEmail_bindClass: function(reservation) {
            var result = {};
            result['fa'] = true;

            if (reservation.email_thanks_requested) {
                result['fa-envelope-circle-check'] = true;
            } else {
                result['fa-envelope'] = true;
            }

            return result;
        },
        creneauRoom_Container_bindClass: function(creneau_key) {
            var result = {};
            result['c' + creneau_key] = true;

            return result;
        },
        creneauRoom_bindClass: function(creneau_key, room_number) {
            var result = {};

            if (this.creneaux_jour[creneau_key].availability['room_' + room_number]) {
                if (this.creneaux_jour[creneau_key].reservations['room_' + room_number]) {
                    result['gmc-no-color'] = true;
                    if (this.creneaux_jour[creneau_key].game_master_colors['room_' + room_number]) {
                        for (var i = 0; i < this.game_master_colors.length; i++) {
                            if (this.game_master_colors[i] == this.creneaux_jour[creneau_key].game_master_colors['room_' + room_number]) {
                                result['gmc-no-color'] = false;
                                result['gmc-color-' + (i + 1)] = true;
                                break;
                            }
                        }
                    }
                } else {
                    let availability_type = this.creneauRoom_getAvailableType(creneau_key, room_number);
                    if (availability_type == 'not_available' || availability_type == 'available_phone') {
                        result['available'] = true;
                    } else {
                        result['available'] = true;
                    }
                }
            } else {
                result['not_available'] = true;
            }

            return result;
        },
        creneauRooms_bindClass: function(creneau_key) {
            var result = {};

            if (this.creneaux_jour[creneau_key].type != 'not_available') {
                result['available'] = true;
            } else {
                result['not_available'] = true;
            }

            return result;
        },
        calendrier_daySelected: function(data) {
            this.creneaux_keys = [];
            for (var key in data.creneaux) {
                this.creneaux_keys.push(key);
            }
            this.creneaux_keys.sort();

            this.creneaux_sets_keys = [];
            for (var key in data.creneaux_sets) {
                this.creneaux_sets_keys.push(key);
            }
            this.creneaux_sets_keys.sort();

            this.isTodaySelected = data.isToday;
            this.creneaux_type = data.type;
            this.creneaux_jour = data.creneaux;
            this.creneaux_sets = data.creneaux_sets;
            this.creneaux_nb_rooms_reservation = data.nb_rooms_reservation;
            this.creneaux_nb_rooms_available = data.nb_rooms_available;
            this.calendarLabel = data.calendarLabel;
            this.calendarIndex = data.calendarIndex;
            this.calendarDay = data.calendarDay;
            this.calendarMonth = data.calendarMonth;
            this.calendarYear = data.calendarYear;

            this.loadReservations();
        },
        calendrier_dayUnselected: function() {
            this.isTodaySelected = false;
            this.creneaux_type = null;
            this.creneaux_keys = null;
            this.creneaux_sets_keys = null;
            this.creneaux_jour = null;
            this.creneaux_sets = null;
            this.creneaux_nb_rooms_reservation = null;
            this.creneaux_nb_rooms_available = null;
            this.calendarLabel = null;
            this.calendarIndex = null;
            this.calendarDay = null;
            this.calendarMonth = null;
            this.calendarYear = null;

            this.reservations = null;
        },
        checkCreneauxSet_availability: function(creneaux_set_key) {
            var nb_creneaux_ouverts = 0;
            var nb_creneaux_fermes = 0;
            var nb_creneaux_reserves = 0;
            for (var i = 0; i < this.creneaux_sets[creneaux_set_key].creneaux.length; i++) {
                let creneau_key = this.creneaux_sets[creneaux_set_key].creneaux[i].creneau;

                if (this.creneaux_jour[creneau_key].reservations['room_1'] === true) {
                    nb_creneaux_reserves++;
                } else if (this.creneaux_jour[creneau_key].availability['room_1'] === true) {
                    nb_creneaux_ouverts++;
                } else if (this.creneaux_jour[creneau_key].availability['room_1'] === false) {
                    nb_creneaux_fermes++;
                }

                if (this.creneaux_jour[creneau_key].reservations['room_2'] === true) {
                    nb_creneaux_reserves++;
                } else if (this.creneaux_jour[creneau_key].availability['room_2'] === true) {
                    nb_creneaux_ouverts++;
                } else if (this.creneaux_jour[creneau_key].availability['room_2'] === false) {
                    nb_creneaux_fermes++;
                }

                if (this.creneaux_jour[creneau_key].reservations['room_3'] === true) {
                    nb_creneaux_reserves++;
                } else if (this.creneaux_jour[creneau_key].availability['room_3'] === true) {
                    nb_creneaux_ouverts++;
                } else if (this.creneaux_jour[creneau_key].availability['room_3'] === false) {
                    nb_creneaux_fermes++;
                }
            }

            if (nb_creneaux_reserves < 3) {
                if (nb_creneaux_ouverts > nb_creneaux_fermes) {
                    return true;
                } else if (nb_creneaux_ouverts < nb_creneaux_fermes) {
                    return false;
                }
            }

            return null;
        },
        loadReservations: function() {
            this.reservations = null;

            axios.get('https://api.lockquest.fr/reservations/' + this.calendarDay + '/' + this.calendarMonth + '/' + this.calendarYear)
                .then((response) => {
                    var _reservations = [];
                    for (var i = 0; i < response.data.length; i++) {
                        var reservation = response.data[i];
                        if (reservation.status !== 'PAYMENT_RECEIVED' && reservation.status !== 'PAYMENT_DELAYED') {
                            continue;
                        }

                        _reservations.push(reservation);
                    }
                    this.reservations = _reservations;
                })
                .catch((error) => {

                });
        },
        btnReservationComment_onClick: function(reservation, scenario) {
            this.$refs.reservationCommentPopin.popin_reservationCommentDisplayed(reservation, scenario);
        },
        btnThanksEmail_onClick: function(obj) {
            this.admin_isProcessing = true;

            axios.get('https://api.lockquest.fr/reservation/email/remerciements/' + obj.id)
                .then((response) => {
                    for (var i = 0; i < this.reservations.length; i++) {
                        if (this.reservations[i].id == obj.id) {
                            this.reservations[i].email_thanks_requested = !this.reservations[i].email_thanks_requested;
                            break;
                        }
                    }
                    this.admin_isProcessing = false;
                }).catch((error) => {
                    this.admin_isProcessing = false;
                    alert('Une erreur est survenue, merci de contacter l\'administrateur.');
                });
        },
        btnClosure_onClick: function(obj) {
            var result = confirm('Vous allez supprimer la réservation de ' + obj.first_name + ' ' + obj.last_name + '. Voulez-vous continuer ?');
            if (result) {
                this.admin_isProcessing = true;

                axios.post('https://api.lockquest.fr/reservation', {
                    action: 'unregister',
                    data: {
                        id: obj.id
                    }
                }, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then((response) => {
                    this.$refs.calendrierComponent.reloadCalendrier(this.calendarIndex);
                    this.admin_isProcessing = false;

                    alert('La réservation a été supprimée !');
                }).catch((error) => {
                    this.admin_isProcessing = false;
                    alert('Une erreur est survenue, merci de contacter l\'administrateur.');
                });
            }
        },
        creneauxSetAvailability_clickAll: function(availability) {
            if (this.admin_isProcessing) {
                return;
            }

            this.admin_isProcessing = true;

            let self = this;
            axios.post('https://api.lockquest.fr/creneaux', {
                day: self.calendarDay,
                month: self.calendarMonth,
                year: self.calendarYear,
                availability: availability
            }, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((response) => {
                self.$refs.calendrierComponent.reloadCalendrier(this.calendarIndex);
                self.admin_isProcessing = false;
            });
        },
        creneauxSetAvailability_click: function(creneaux_set_key, availability) {
            if (this.admin_isProcessing) {
                return;
            }

            this.admin_isProcessing = true;
            this.creneauxSetAvailability_processId = creneaux_set_key;

            var request_index = 0;
            var nb_requests = 0;

            let liste_creneaux = this.creneaux_sets[creneaux_set_key].creneaux;
            for (var i = 0; i < liste_creneaux.length; i++) {
                for (var j = 0; j < liste_creneaux[i].rooms.length; j++) {
                    if (this.creneaux_jour[liste_creneaux[i].creneau].reservations[liste_creneaux[i].rooms[j]]
                        || this.creneaux_jour[liste_creneaux[i].creneau].availability[liste_creneaux[i].rooms[j]] == availability) {
                        continue;
                    }

                    let self = this;
                    async function perform_availabilityRequest(creneau, room, availability) {
                        nb_requests = nb_requests + 1;

                        await new Promise((resolve) => setTimeout(resolve, 270 * request_index));
                        await axios.post('https://api.lockquest.fr/creneau', {
                            day: self.calendarDay,
                            month: self.calendarMonth,
                            year: self.calendarYear,
                            creneau: creneau,
                            availability: availability,
                            room: room,
                        }, {
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                        }).then((response) => {
                            self.creneaux_jour[creneau].availability[room] = availability;
                            nb_requests = nb_requests - 1;
                            if (nb_requests <= 0) {
                                self.creneauxSetAvailability_processId = null;
                                self.admin_isProcessing = false;
                            }
                        });
                    };
                    perform_availabilityRequest(liste_creneaux[i].creneau, liste_creneaux[i].rooms[j], availability);

                    request_index = request_index + 1;
                }
            }
        },
        creneauRoomAvailabilityException_clicked: function(creneau_key, room_number) {
            console.error('creneauRoomAvailabilityException_clicked(' + creneau_key + ',' + room_number + ')');
            if (this.admin_isProcessing) {
                return;
            }

            this.admin_isProcessing = true;

            let availability_exception = this.creneauRoom_checkExceptions(creneau_key, room_number);
            console.error(availability_exception);
            if (availability_exception) {
                availability_exception = 'available';
            } else {
                availability_exception = 'available_phone';
            }
            console.error("=> " + availability_exception);
            axios.post('https://api.lockquest.fr/creneau/reservation/availability_exception', {
                day: this.calendarDay,
                month: this.calendarMonth,
                year: this.calendarYear,
                creneau: creneau_key,
                room: 'room_' + room_number,
                availability_exception: availability_exception
            }, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((response) => {
                this.$refs.calendrierComponent.reloadCalendrier(this.calendarIndex);
                this.admin_isProcessing = false;
            }).catch((error) => {
                if (error.response.data) {
                    alert(error.response.data);
                }
                this.admin_isProcessing = false;
            });
        },
        creneauRoom_clicked: function(creneau_key, room_number) {
            if (this.admin_isProcessing) {
                return;
            }

            this.admin_isProcessing = true;

            if (this.creneaux_jour[creneau_key].reservations['room_' + room_number]) {
                var game_master_color_found = false;
                for (var i = 0; i < this.game_master_colors.length; i++) {
                    if (this.game_master_colors[i] == this.creneaux_jour[creneau_key].game_master_colors['room_' + room_number]) {
                        if (i == this.game_master_colors.length - 1) {
                            this.creneaux_jour[creneau_key].game_master_colors['room_' + room_number] = null;
                        } else {
                            this.creneaux_jour[creneau_key].game_master_colors['room_' + room_number] = this.game_master_colors[(i + 1)];
                        }

                        game_master_color_found = true;
                        break;
                    }
                }

                if (!game_master_color_found) {
                    this.creneaux_jour[creneau_key].game_master_colors['room_' + room_number] = this.game_master_colors[0];
                }

                axios.post('https://api.lockquest.fr/creneau/reservation/alloc', {
                    day: this.calendarDay,
                    month: this.calendarMonth,
                    year: this.calendarYear,
                    creneau: creneau_key,
                    room: 'room_' + room_number,
                    game_master_color: this.creneaux_jour[creneau_key].game_master_colors['room_' + room_number]
                }, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then((response) => {
                    this.admin_isProcessing = false;
                }).catch((error) => {
                    this.admin_isProcessing = false;
                    alert('Une erreur interne est survenue, merci de ré-essayer plus tard ou de contacter l\'administrateur.');
                });
            } else {
                axios.post('https://api.lockquest.fr/creneau', {
                    day: this.calendarDay,
                    month: this.calendarMonth,
                    year: this.calendarYear,
                    creneau: creneau_key,
                    availability: !this.creneaux_jour[creneau_key].availability['room_' + room_number],
                    room: 'room_' + room_number,
                }, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then((response) => {
                    this.$refs.calendrierComponent.reloadCalendrier(this.calendarIndex);
                    this.admin_isProcessing = false;
                }).catch((error) => {
                    this.admin_isProcessing = false;
                    alert('Il n\'est pas possible de modifier le statut d\'une room si celle-ci est déjà réservée sur ce créneau.');
                });
            }
        },
        update_creneauxSetAlloc: function(creneaux_set_key) {
            if (this.admin_isProcessing) {
                return;
            }

            this.admin_isProcessing = true;
            this.creneauAlloc_processStep = 'requesting';
            this.creneauAlloc_processId = creneaux_set_key;

            axios.post('https://api.lockquest.fr/creneaux/set/alloc', {
                day: this.calendarDay,
                month: this.calendarMonth,
                year: this.calendarYear,
                creneaux_set: creneaux_set_key,
                game_master_nb: this.creneaux_sets[creneaux_set_key].game_master_nb ? this.creneaux_sets[creneaux_set_key].game_master_nb : null
            }, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((response) => {
                this.creneauAlloc_processStep = 'done';

                let self = this;
                setTimeout(function() {
                    self.creneauAlloc_processStep = null;
                    self.creneauAlloc_processId = null;

                    self.admin_isProcessing = false;
                }, 1250);
            }).catch((error) => {
                this.admin_isProcessing = false;
                this.creneauAlloc_processStep = null;

                if (error.response.status && error.response.status == 400) {
                    alert(error.response.data);
                } else {
                    alert('Une erreur interne est survenue, merci de ré-essayer plus tard ou de contacter l\'administrateur.');
                }
            });
        }
    },
    mounted() {
        this.$refs.calendrierComponent.initializeCalendrier();

        let fontAwesomeKit_script = document.createElement('script');
        fontAwesomeKit_script.setAttribute('src', 'https://kit.fontawesome.com/6c0996167f.js');
        fontAwesomeKit_script.setAttribute('crossorigin', 'anonymous');
        document.head.appendChild(fontAwesomeKit_script);
    }
}
</script>